import {FIELD_NAME} from './pcConstAppData';

export const ConicalType = {
  15: 15,
  50: 50,
};

export const ConicalOptionsV3 = [
  {
    value: ConicalType[15],
    label: ConicalType[15].toString(),
  },
  {
    value: ConicalType[50],
    label: ConicalType[50].toString(),
  },
];

export const ConicalOptionsV2 = [
  {
    value: ConicalType[50],
    label: ConicalType[50].toString(),
  },
];

export const MembraneCutOffOptions = [
  {
    value: 3,
    label: '3',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 50,
    label: '50',
  },
  {
    value: 100,
    label: '100',
  },
  {
    value: 300,
    label: '300',
  },
];

export const MembraneCutOffRCOptions = [
  {
    value: 3,
    label: '3',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 10,
    label: '10',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 100,
    label: '100',
  },
   {
    value: 300,
    label: '300',
  },
];

export const AutoProfileSetupMode = {
  0: FIELD_NAME.CONCENTRATE,
  1: FIELD_NAME.CONC_TWO_TUBES,
  2: FIELD_NAME.BUFFER_EXCHANGE,
};

export const AutoProfileSetupModes = Object.entries(AutoProfileSetupMode).map((e) => ({
  id: Number(e[0]),
  value: e[1],
}));
